import React from "react";
import { CalendarDays, CircleX } from "lucide-react";
import Grid from "../Grid";
import FidelisMessageBarChart from "../Chart/FidelisMessageBarChart";
import FidelisMessageStatusDonutChart from "../Chart/FidelisMessageStatusDonutChart";
import Spacing from "../Spacing";
import DatePicker from "react-datepicker";
import { createPortal } from "react-dom";
import Skeleton from "react-loading-skeleton";
const PopperContainer = ({ children }) => createPortal(children, document.body);

export default function FidelisMessageSection({
  filter = {},
  setFilter = () => {},
  dateRange = [],
  setDateRange = () => {},
  handleDateChange = () => {},
  resultDate = null,
  totalMessageSent = {},
  totalMessageStatus = {},
  messageDataLoading = false,
}) {

  return (
    <>
      <div className="docpro_flex_box">
        <h2 className="docpro_fs_20 docpro_mb_0">Fidelis Care Message Summery</h2>
        <div className="docpro_tab_btns_2">
          <div className="flex items-center">
            <div className="docpro_toggle_calendar">
              <CalendarDays />

              <DatePicker
                selectsRange={true}
                startDate={dateRange[0]}
                endDate={dateRange[1]}
                onChange={handleDateChange}
                popperContainer={PopperContainer}
                popperPlacement="bottom-end"
                showPopperArrow
              />

              {resultDate}
            </div>
            {resultDate && (
              <span 
                onClick={() => {
                  setFilter({
                    ...filter,
                    start_date: "",
                    end_date: "",
                  });
                  setDateRange([null, null]);
                }}
                style={{ marginRight: '6px', marginLeft: '-2px' }}
              >
                <CircleX size={20} color="#e15759" className="pointer" />
              </span>
            )}
          </div>
        </div>
      </div>
      <Spacing lg="10" sm="10" />
      <Grid variant="docpro_grid_gap_20 docpro_dashboard_grid_col_3">
        {messageDataLoading ? (
          <div className="docpro_grid_col_2">
            <Skeleton width="100%" height="18rem" borderRadius="8px"></Skeleton>
          </div>
        ) : (
          <>
            {Object.keys(totalMessageSent).length > 0 ? (
              <div className="docpro_grid_col_2">
                <FidelisMessageBarChart
                  totalMessageSent={totalMessageSent}
                />
              </div>
            ) : (
              <div className="docpro_grid_col_2 flex items-center docpro_fidelis_care_no_data">
                Message not found!
              </div>
            )}
          </>
        )}
        {messageDataLoading ? (
          <div className="docpro_grid_col_1">
            <Skeleton width="100%" height="18rem" borderRadius="8px"></Skeleton>
          </div>
        ) : (
          <>
            {Object.keys(totalMessageStatus).length > 0 ? (
              <div className="docpro_grid_col_1">
                <FidelisMessageStatusDonutChart
                  totalMessageStatus={totalMessageStatus}
                />
              </div>
            ) : (
              <div className="docpro_grid_col_1 flex items-center docpro_fidelis_care_no_data">
                Message not found!
              </div>
            )}
          </>
        )}
      </Grid>
    </>
  );
}
